module.exports = "<td class=\"table-column\" v-show=\"visible\" :data-label=\"label\" :key=\"column_id\"><slot></slot></td>\n"